export default {
    parseNewTicketData(storeData) {
        var data = storeData.data;
        var response = storeData.response;
        var user = storeData.user;
        var system = storeData.system;

        var newTicket = {
            createdByContact: user.name,
            createdByContactID: user.id,
            dateClosed: null,
            dateOpened: response.dateOpened,
            description: data.description,
            dhrNumber: response.dhrNumber,
            id: response.id,
            lastUpdated: response.lastUpdated,
            ownerId: /*response.ownedBy*/'',
            ownerName: '',
            priority: response.priority,
            priorityID: null,
            productConfiguration: system.productConfigurationDescription,
            shortSummary: data.shortSummary,
            status: response.status,
            statusId: response.statusID,
            supportTicketNature: response.nature,
            supportTicketNatureId: response.natureID,
            systemOperable: data.systemOperable
        }

        if (response.priority == 'Low') {
            newTicket.priorityID = 3;
        } else if (response.priority == 'Normal') {
            newTicket.priorityID = 3;
        } else if (response.priority == 'High') {
            newTicket.priorityID = 1;
        } else {
            newTicket.priority = 'Normal';
            newTicket.priorityID = 3;
        }

        return {
            ticket: newTicket,
            system: system
        }
    }
}
